"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "artena": {
    "e829879b": [{
      "hkey": "c786927b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "abbazia": [{
      "hkey": "c786927b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "artena"
    }],
    "f73eb0d8": [{
      "hkey": "c786927b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "maiotini": [{
      "hkey": "c786927b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "artena"
    }],
    "33622c62": [{
      "hkey": "a0bce9c0",
      "slug": "artena",
      "name": "Artena",
      "primary": true,
      "skipSearch": false
    }],
    "selvatico": [{
      "hkey": "a0bce9c0",
      "slug": "artena",
      "name": "Artena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db66bec0": [{
      "hkey": "a0bce9c0",
      "slug": "artena",
      "name": "Artena",
      "primary": true,
      "skipSearch": false
    }],
    "valli": [{
      "hkey": "a0bce9c0",
      "slug": "artena",
      "name": "Artena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;